import {CSSProperties} from 'react'

export const bps = ['sm', 'md', 'lg', 'xl', 'xxl'] as const

export type BP = (typeof bps)[number]

export const breakpoints = {
  sm: '568px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  xxl: '1440px',
} as const satisfies {[k in BP]: string}

export const bpx = ['_', 'xs', ...bps] as const

export type BPX = (typeof bpx)[number]

export const atBreakpointsWith =
  <V>(fn: (v: V) => CSSProperties | undefined) =>
  (input: {[k in BPX]?: V}) =>
    bpx.reduce((output, bp) => {
      const o = bp in input && fn(input[bp] as V)
      if (o) {
        if (bp === '_' || bp === 'xs') {
          Object.assign(output, o)
        } else {
          output[`@media (min-width: ${breakpoints[bp]})`] = o
        }
      }
      return output
    }, {} as any)

export const atBreakpoints = atBreakpointsWith(
  (v: CSSProperties | undefined) => v,
)
